import { Loader } from "appcues-loader";
import LocalStoreManager from "./local-store-manager";
import { get } from "lodash";

const ACCOUNT_ID = get(process.env, "VUE_APP_APPCUE_ACCOUNT_ID");

export const getAppcuesLoader = async () => {
  let appcues = null;

  if (ACCOUNT_ID) {
    const loader = new Loader(ACCOUNT_ID);
    appcues = await loader.load();
  }

  return appcues;
};

export const identifyUser = (appcues) => {
  const currentUserId = new LocalStoreManager().getUserId();
  const currentUserEmail = new LocalStoreManager().getUserEmail();
  appcues.identify(currentUserId, {
    email: currentUserEmail,
  });
};

export const identifyUserProperties = (appcues, properties = {}) => {
  if (appcues) {
    const currentUserId = new LocalStoreManager().getUserId();
    appcues.identify(currentUserId, properties);
  }
};
